import { useRef, type MouseEvent, type PointerEvent } from 'react';

/** A press that travels further than this was a pan, not a click. */
const DRAG_TOLERANCE_PX = 5;

/**
 * Props for a map wrapper that reports clicks on the empty map — not on a
 * badge or control (any button/link inside) and not the tail of a pan. The
 * vendor map click listener is deliberately not used: it reports a beat late
 * (it waits out a possible double-click), which let it undo a badge selection
 * made just before.
 */
export function useBackgroundClick(onBackgroundClick: () => void) {
  const pressed = useRef<{ x: number; y: number } | null>(null);
  return {
    onPointerDown: (event: PointerEvent) => {
      pressed.current = { x: event.clientX, y: event.clientY };
    },
    onClick: (event: MouseEvent) => {
      if ((event.target as Element).closest('button, a')) return;
      const start = pressed.current;
      if (
        start &&
        Math.hypot(event.clientX - start.x, event.clientY - start.y) > DRAG_TOLERANCE_PX
      )
        return;
      onBackgroundClick();
    },
  };
}
